<template>
  <v-container fluid>
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Audiences Reporting</h1>
      </v-col>
      <v-col cols="12">
        <span>How is each one of your audiences performing?</span>
      </v-col>
      <v-col cols="12">
        <v-row align="start">
          <v-col cols="12" md="4">
            <audience-report-item-selector
              :campaigns="campaigns"
              :pickerOptions="pickerOptions"
            />
          </v-col>
          <v-spacer />
          <v-col cols="12" md="4">
            <the-date-picker
              v-if="dates.length >= 2"
              :initialDates="dates"
              @setDate="setReportingDates"
              class="mt-2"
            />
          </v-col>
        </v-row>
      </v-col>
<!--      <v-col cols="12">-->
<!--        <highcharts :options="options" ref="highcharts"></highcharts>-->
<!--      </v-col>-->
      <v-col cols="12">
        <v-row class="ma-0">
          <v-col cols="12" md="5">
            <highcharts :options="options_left" ref="highcharts-left" />
            <!-- <button @click="updateCredits">update credits</button> -->
          </v-col>
          <v-spacer />
          <v-col cols="12" md="5">
            <highcharts :options="options_right" ref="highcharts-right" />
            <!-- <button @click="updateCredits">update credits</button> -->
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <audiences-report-table
          :files="files"
          @startStopCampaign="startStopCampaign"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AudienceReportItemSelector from './AudienceReportItemSelector.vue'
  import AudiencesReportTable from './AudienceReportTable.vue'
  import TheDatePicker from '../../helpers/TheDatePicker.vue'
  export default {
    name: 'audience-report',
    components: {
      AudienceReportItemSelector,
      AudiencesReportTable,
      TheDatePicker
    },
    data () {
      return {
        options: {
          title: {
            text: 'Campaign Spend',
            x: -20 // center
          },
          xAxis: {
            categories: ['Jun 14', 'Jun 15', 'Jun 16', 'Jun 17', 'Jun 18', 'Jun 19',
              'Jun 20', 'Jun 21', 'Jun 22', 'Jun 23', 'Jun 24', 'Jun 25'
            ]
          },
          yAxis: {
            title: {
              text: '$'
            },
            plotLines: [{
              value: 0,
              width: 1,
              color: '#808080'
            }]
          },
          tooltip: {
            valuePrefix: '$',
            valueSuffix: ''
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            borderWidth: 0
          },
          series: [{
            name: 'Parents',
            type: 'spline',
            data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6]
          }, {
            name: 'Seniors',
            type: 'spline',
            data: [-0.2, 0.8, 5.7, 11.3, 17.0, 22.0, 24.8, 24.1, 20.1, 14.1, 8.6, 2.5]
          }, {
            name: 'Students',
            type: 'spline',
            data: [-0.9, 0.6, 3.5, 8.4, 13.5, 17.0, 18.6, 17.9, 14.3, 9.0, 3.9, 1.0]
          }]
        },
        options_left: {
            chart: {
                type: 'bar',
                style: { color: 'black', fontFamily: "Roboto, sans-serif", fontWeight: 'normal', textShadow: 'none' }
            },
            title: {
                text: 'Budget Spent',
                align: 'left',
                style: { fontSize: '22px', fontFamily: "Roboto, sans-serif", fontWeight: '700' }
            },
            xAxis: {
                categories: ['Seniors', 'Parents', 'Students'],
                title: {
                    text: null
                }
            },
            yAxis: {
                min: 0,
                title: {
                    enabled: false
                },
                labels: {
                    overflow: 'justify'
                }
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        // eslint-disable-next-line
                        format: '${y}',
                        enabled: true
                    }
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            series: [{
                data: [19.52, 15.24, 10.15]
            }]
        },
        options_right: {
            chart: {
                type: 'bar',
                style: { color: 'black', fontFamily: "Roboto, sans-serif", fontWeight: 'normal', textShadow: 'none' }
            },
            title: {
                text: 'Cost per Action',
                align: 'left',
                style: { fontSize: '22px', fontFamily: "Roboto, sans-serif", fontWeight: '700' }
            },
            xAxis: {
                categories: ['Seniors', 'Parents', 'Students'],
                title: {
                    text: null
                }
            },
            yAxis: {
                min: 0,
                title: {
                    enabled: false
                },
                labels: {
                    overflow: 'justify'
                }
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        // eslint-disable-next-line
                        format: '${y}',
                        enabled: true
                    }
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            series: [{
                data: [2.25, 1.50, 0.66]
            }]
        },
        filesTableActive: true,
        files: [
          {
            id: 1,
            list: 'Parents',
            insights: {
              spend: 15.24,
              reach: 1200,
              total_actions: 10,
              cost_per_total_action: 1.50,
              clicks: 15,
              cpc: 1.00,
              impressions: 3205,
              cpm: 5.14,
              ctr: 5.0
            },
            uploaded: '2018-04-20',
            status: 'processing',
            size: 'TBD',
            active: true,
            options: {
              title: {
                text: 'Week performance',
                x: -20 // center
              },
              xAxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                ]
              },
              yAxis: {
                title: {
                  text: '$K'
                },
                plotLines: [{
                  value: 0,
                  width: 1,
                  color: '#808080'
                }]
              },
              tooltip: {
                valuePrefix: '$',
                valueSuffix: 'K'
              },
              legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                borderWidth: 0
              },
              series: [{
                name: 'Parents',
                type: 'spline',
                data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6]
              }, {
                name: 'Seniors',
                type: 'spline',
                data: [-0.2, 0.8, 5.7, 11.3, 17.0, 22.0, 24.8, 24.1, 20.1, 14.1, 8.6, 2.5]
              }, {
                name: 'Students',
                type: 'spline',
                data: [-0.9, 0.6, 3.5, 8.4, 13.5, 17.0, 18.6, 17.9, 14.3, 9.0, 3.9, 1.0]
              }]
            }
          },
          {
            id: 2,
            list: 'Seniors',
            insights: {
              spend: 19.52,
              reach: 1800,
              total_actions: 12,
              cost_per_total_action: 2.25,
              clicks: 19,
              cpc: 1.00,
              impressions: 2808,
              cpm: 9.52,
              ctr: 0.2
            },
            uploaded: '2018-04-19',
            status: 'Too small',
            size: '< 1000',
            active: true,
            options: {
              title: {
                text: 'Week performance',
                x: -20 // center
              },
              xAxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                ]
              },
              yAxis: {
                title: {
                  text: '$K'
                },
                plotLines: [{
                  value: 0,
                  width: 1,
                  color: '#808080'
                }]
              },
              tooltip: {
                valuePrefix: '$',
                valueSuffix: 'K'
              },
              legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                borderWidth: 0
              },
              series: [{
                name: 'Parents',
                type: 'spline',
                data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6]
              }, {
                name: 'Seniors',
                type: 'spline',
                data: [-0.2, 0.8, 5.7, 11.3, 17.0, 22.0, 24.8, 24.1, 20.1, 14.1, 8.6, 2.5]
              }, {
                name: 'Students',
                type: 'spline',
                data: [-0.9, 0.6, 3.5, 8.4, 13.5, 17.0, 18.6, 17.9, 14.3, 9.0, 3.9, 1.0]
              }]
            }
          },
          {
            id: 3,
            list: 'Students',
            insights: {
              spend: 10.15,
              reach: 900,
              total_actions: 15,
              cost_per_total_action: 0.66,
              clicks: 20,
              cpc: 0.50,
              impressions: 2534,
              cpm: 5.20,
              ctr: 1.0
            },
            uploaded: '2018-04-19',
            status: 'Ready',
            size: '2,025',
            active: true,
            options: {
              title: {
                text: 'Week performance',
                x: -20 // center
              },
              xAxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                ]
              },
              yAxis: {
                title: {
                  text: '$K'
                },
                plotLines: [{
                  value: 0,
                  width: 1,
                  color: '#808080'
                }]
              },
              tooltip: {
                valuePrefix: '$',
                valueSuffix: 'K'
              },
              legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                borderWidth: 0
              },
              series: [{
                name: 'Parents',
                type: 'spline',
                data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6]
              }, {
                name: 'Seniors',
                type: 'spline',
                data: [-0.2, 0.8, 5.7, 11.3, 17.0, 22.0, 24.8, 24.1, 20.1, 14.1, 8.6, 2.5]
              }, {
                name: 'Students',
                type: 'spline',
                data: [-0.9, 0.6, 3.5, 8.4, 13.5, 17.0, 18.6, 17.9, 14.3, 9.0, 3.9, 1.0]
              }]
            }
          }
        ],
        next: true,
        initialDates: []
      }
    },
    props: {
      page: {
        type: String,
        default: 'audiences-report-table'
      },
      dates: {
        type: Array,
        default: () => []
      },
      pickerOptions: {
        type: Object,
        default: () => {}
      }
    },
    mounted () {
      this.initialDates.push(this.$moment().subtract(14, 'days'))
      this.initialDates.push(this.$moment())
    },
    computed: {
      activeComponent () {
        if (this.filesTableActive) return 'files-table'
        return 'stepper'
      },
      campaigns () {
        return this.$store.getters.getCampaigns
      }
    },
    methods: {
      setReportingDates (dates) {
        this.$store.commit('helpers/SET_REPORTING_DATES', dates)
        this.$emit('updateInsights')
      },
      updateCredits () {
        let chart = this.$refs.highcharts.chart
        chart.credits.update({
          style: {
            color: '#' + (Math.random() * 0xffffff | 0).toString(16)
          }
        })
      },
      startStopCampaign (id) {
        let file = this.files.find(f => f.id === id)
        if (file) file.active = !file.active
      }
    }
  }
</script>
<style>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100% !important;
  }
</style>
